<template>
    <ConfirmDialog group="dialog" />
    <Toast />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('inquiry.view.Inquiry Details') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.Title') }}:</label>
                    <div class="p-col-12 p-md-10">{{ title }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.Content') }}:</label>
                    <div class="p-col-12 p-md-10">{{ consultation }}</div>
                </div>
                <!-- <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.Id') }}:</label>
                    <div class="p-col-12 p-md-10">{{ unique_id }}</div>
                </div> -->
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.UserType') }}:</label>
                    <div v-if="user_type !== null" class="p-col-12 p-md-10">{{ user_type === 'job_seeker' ? 'Job Seeker'
                            : 'Recruiter'
                    }}</div>
                    <div v-else class="p-col-12 p-md-10">N/A</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.Email') }}:</label>
                    <div class="p-col-12 p-md-10">{{ email }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.Phone') }}:</label>
                    <div class="p-col-12 p-md-10">{{ formatPhoneNumber(phone_number) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('inquiry.view.Password') }}:</label>
                    <div class="p-col-12 p-md-10">{{ password }}</div>
                </div>
                <div class="line-3">
                    <hr>
                </div>
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col">
                        <strong>
                            <label for="title">{{ $t('inquiry.view.Admin Reply') }}</label>
                        </strong>
                        <Textarea class="p-mt-3" inputId="textarea" rows="3" cols="30" v-model="answer"
                            :placeholder="$t('inquiry.view.Desc')" @keydown.space="preventLeadingSpace"></Textarea>

                    </div>
                </div>
                <div class="p-d-flex p-jc-between">
                    <!-- <router-link to="/view-user"
                        ><Button label="info" class="p-button-outlined p-button-info p-mr-2 p-mb-2" disabled><i class="pi pi-eye p-mr-2"></i>point</Button>
                    </router-link>-->
                    <!-- <router-link :to="'/faq/edit/' + $route.params.id">
                        <Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2"> <i class="pi pi-user-edit p-mr-2"></i> Edit </Button>
                    </router-link> -->
                    <Button @click="reply()" :label="$t('inquiry.view.BtnReply')" class="p-button-outlined p-mr-2 p-mb-2"
                        style="background: black; color: white;" icon="pi pi-check" iconPos="left">

                    </Button>
                    <Button :label="$t('notice1.edit.Back')" icon="pi pi-replay" iconPos="left"
                        class="p-button1 p-component p-button-outlined p-button-sm p-mr-2 p-mb-2"
                        @click="$router.go(-1)" style="background: white; color: black"> </Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import InquiryService from '../../service/API/InquiryService';
// import {useRouter} from 'vue-router'
export default {
    data() {
        return {
            disInq: true,
            renderTxt: false,
            replied: false,
            answer: '',
            replyStatus: 'answered',
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            id: '',
            title: '',
            email: '',
            phone_number: '',
            user_type: '',
            password: '',
            consultation: '',
            unique_id: '',
        };
    },
    created() {
        this.inquiryService = new InquiryService();
    },
    methods: {
        reply() {
            if (this.answer != '') {
                this.inquiryService.inquiryReply(this.$route.params.id, this.answer).then(() => {
                    // this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '답변이 성공적으로 전송되었습니다. ', life: 1000 });
                    this.$router.push({ name: 'Inquiry' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '답변이 성공적으로 전송되었습니다.', life: 3000 });
                    }, 500);
                });
            } else {
                this.$toast.add({ severity: 'error', summary: '반려', detail: '답변 필드는 비어있으면 안됩니다.', life: 3000 });
            }
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            }
            else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            }
            else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: 'Confirmation',
                message: 'Are you sure you want to delete?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    axios({ method: 'delete', url: `/faq/delete`, data: { deleteIdArray: id } }).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'Inquiry' });
                    });

                    this.$toast.add({ severity: 'info', summary: 'Deleted', detail: 'Deleted successfully', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                },
            });
        },
    },
    mounted() {
        this.inquiryService.viewInquiry(this.$route.params.id).then((data) => {
            console.log(data);
            this.answer = data[0].answer;
            this.email = data[0].email;
            this.password = data[0].password;
            this.user_type = data[0].user_type;
            this.phone_number = data[0].phone_number;
            this.title = data[0].title;
            this.consultation = data[0].consultation;
            this.unique_id = data[0].unique_id;
            this.mydata = data;
            if (data.status == 'not_answered') {
                this.renderTxt = true;
                this.replied = false;
                this.disInq = false;
            } else {
                this.renderTxt = false;
                this.replied = true;
                this.disInq = true;
            }
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}
</style>
